<template>
  <v-container fluid>

    <v-row v-if="!isLoading && !errorMessage">
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :options.sync="options"
          :loading="apiLoading"
          ref="dataTable"
          :loading-text="$t('wkt.admin.common.table.loading')"
          :no-data-text="$t('wkt.admin.common.table.no_data')"
          :no-results-text="$t('wkt.admin.common.table.no_results')"
					:footer-props="{
						'items-per-page-options': [20, 50, 100],
						'items-per-page-text': $t('wkt.admin.common.table.items_per_page'),
						'items-per-page-all-text': $t('wkt.admin.common.table.items_per_page_all')
					}"
          :disablePagination="true" hide-default-footer
            :fixedHeader="true"
        >
          <template v-slot:top>
            <v-toolbar flat color="white" class="mb-3">
              <v-row cols="12" class="mt-0" v-if="!isLoading && !errorMessage">
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="search"
                    :label="$t('wkt.admin.forms.table.search')"
                    hide-details
                    :clearable="true"
                    @click:clear="searchTimeOut()"
                    @keyup="searchTimeOut()"
                  />
                </v-col>
              </v-row>
            </v-toolbar>
          </template>

					<template v-slot:[`item`]="{ item }">
						<tr style="cursor: pointer;" @click="editItem(item)">
							<td>{{ formatLongDateTime(item.creationDate, true) }}</td>
							<td>{{ item.name }}</td>
							<td>{{ item.externalId }}</td>
							<td>{{ formatLongDateTime(item.updateDate, true) }}</td>
							<td>{{ item.enabled === true ? $t("wkt.admin.common.yes") : $t("wkt.admin.common.no") }}
							</td>
						</tr>
					</template>
        </v-data-table>
      </v-col>
    </v-row>

		<v-tooltip left>
			<template v-slot:activator="{ on, attrs }">				
				<v-btn :dark="licenseType" fixed bottom right fab color="#185EA9" v-bind="attrs" v-on="on" :disabled="!licenseType" @click="addItem()">
					<v-icon dark>add</v-icon>
				</v-btn>
			</template>
			<span>{{ $t("wkt.admin.forms.button-add") }}</span>
		</v-tooltip>

    <ReportTypeDialog ref='dlgReportType'/>

    <!-- INICIO BLOQUE MENSAJE ESTADO PETICIONES -->
    <v-snackbar
      v-model="showAlert"
      :timeout="alertTimeout"
      :color="alertColor">
        <span style="color: #ffffff;">{{alertText}}</span>
        <v-btn text @click="showAlert=false">
          <span style="color: #ffffff;">Cerrar</span>
        </v-btn>
    </v-snackbar>
    <!-- FIN BLOQUE ESTADO PETICIONES -->

  </v-container>
</template>

<script>
import BaseModule from '../common/BaseModule.js'
import api from '../../api/worktime'
import ReportTypeDialog from './FormDialog'
import gwt from '../../api/gwt'

export default {
  name: 'FormModule',
	mixins: [BaseModule],
  components: {
		ReportTypeDialog
  },

  data () {
      return { 
        isLoading: false,
				apiLoading: false,
				errorMessage: null,
				showAlert: false,
				alertColor: 'error',
				alertText: '',
				alertTimeout: 3000,
				search: "",
				options: { itemsPerPage: 20 },
				totalItems: 0,
                tableHeight:200,
				myCompany: null,	
				licenseType: true,			
        headers: [
          { text: this.$t("wkt.admin.forms.table.headers.creation-date"), value: 'creationDate', width: '15%' },
          { text: this.$t("wkt.admin.forms.table.headers.name"), value: 'name', width: '15%' },
          { text: this.$t("wkt.admin.forms.table.headers.reference"), value: 'externalId', width: '10%' },
          { text: this.$t("wkt.admin.forms.table.headers.update-date"), value: 'updateDate', width: '15%' },
          { text: this.$t("wkt.admin.forms.table.headers.enabled"), value: 'enabled', width: '10%' },
          //{ text: '', value: 'actions', sortable: false, width: '120px' },
        ],
				companies: [],
				items: []
      }
    },
  methods: {
    /*formatDateTime (value) {
			return !value ? '' : new Date(value).toLocaleDateString() + ' ' + new Date(value).toLocaleTimeString();
    },*/
		doShowAlert: function(payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
		},
	onReveal() {
			
		if (this.mustRefresh()) {
			this.getItems();
		}
		this.myCompany = gwt.getSessionInformation().company;
				
		
				switch (this.myCompany.licenseType) {
				case 0:
					this.licenseType = false;
					break;
				case 1:
					this.licenseType = true;
					break;
				case 2:
					this.licenseType = true;
					break;
				default:
					this.licenseType = true;
			}
	},
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
				this.options.page = 1;
        this.getItems();
      }, 800);
    },
		addItem() {
			this.openDetailDialog(null);
		},
		editItem(item) {
			var me = this;

			api.getFormById(item.id,
				data => {
					me.openDetailDialog(data);
				},
				err => {
					console.log(err);
					this.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
				});			
		},
		openDetailDialog(data) {
			this.$refs.dlgReportType.open(this.companies, data, (message, result) => {
				if (result) {
					this.getItems();
					if (message) {
						this.doShowAlert({ text: message, color: 'success', timeout: 3000 });
					}
				} else {
					if (message) {
						this.doShowAlert({ text: message, color: 'error', timeout: 3000 });
					}
				}
			});
		},
		getItems() {
				//this.isLoading = true;
				this.apiLoading = true;
				// eslint-disable-next-line no-unused-vars
				const { sortBy, sortDesc, page, itemsPerPage } = this.options;

				api.getForms((page ? page - 1 : 0) * itemsPerPage, itemsPerPage,  this.search ? this.search : '', sortBy ? sortBy : '', sortDesc,
				data => {
						//this.isLoading = false;
						this.apiLoading = false;
						this.items = data.entities;
						this.totalItems = data.total;
				}, err => {
						console.log(err);
						this.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
				});
		},
  }, 
	watch: {
		options: {
			handler () {
				this.$log.debug(this.options);
				this.getItems();
			},
			deep: true,
		},
	},
}
</script>

